import styles from './ChapterBadge.module.css';

type Props = {
  number: number;
  active?: boolean;
  size?: 'sm' | 'md';
};

export default function ChapterBadge({ number, active = false, size = 'md' }: Props) {
  return (
    <span
      className={`${styles.badge} ${styles[`size-${size}`]} ${active ? styles.active : ''}`}
    >
      {number}
    </span>
  );
}
